import { render, staticRenderFns } from "./goodsdetail.vue?vue&type=template&id=529d98ad&scoped=true"
import script from "./goodsdetail.vue?vue&type=script&lang=js"
export * from "./goodsdetail.vue?vue&type=script&lang=js"
import style0 from "./goodsdetail.vue?vue&type=style&index=0&id=529d98ad&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529d98ad",
  null
  
)

export default component.exports